module.exports = __webpack_public_path__ + "static/media/arrows.b15482ee.svg";